import { Component, Input, Output, EventEmitter } from '@angular/core';
import {Feedback} from "../../../models/feedback";
import {FeedbackService} from "../../../services/feedback.service";
import {ToastrService} from "ngx-toastr";

@Component({
  selector: 'app-modal-feedback',
  templateUrl: './modal-feedback.component.html',
  styleUrl: './modal-feedback.component.css',
  standalone: false
})
export class ModalFeedbackComponent {
  @Input() showModalFeedback = false;
  @Output() showModalFeedbackChange = new EventEmitter<boolean>();

  feedback = new Feedback();
  salvando = false;

  constructor(private feedbackService: FeedbackService,
              private toastr: ToastrService) {
  }

  salvarFeedback(){
    this.salvando = true;
    this.feedbackService.adicionar(this.feedback).subscribe(
      result => {
        this.salvando = false;
        if(result.sucesso){
          this.toastr.success("Feedback enviado com sucesso. Agradecemos e vamos trabalhar para melhorar nosso sistema!");
          this.feedback = new Feedback();
          this.fecharModal();
        }
      },
      error => {
        this.salvando = false;
      }
    );
  }

  fecharModal(){
    this.showModalFeedback = false;
    this.showModalFeedbackChange.emit(this.showModalFeedback);
  }
}
